export const ScanningDevices = {
  en: {
    'Scanning Devices': 'Scanning Devices',
    'Staff Passes': 'Staff Passes',
    Identifier: 'Identifier',
    Location: 'Location',
    'Scanner Type': 'Scanner Type',
    'Create Scanning Device': 'Create Scanning Device',
    Delete: 'Delete',
    'Configure scanner': 'Configure scanner',
    'QR-code': 'QR-code',
    'Scan this QR code with your scanning device':
      'Scan this QR code with your scanning device',
    'Connect scanning device form': 'Connect scanning device form',
    'Enter Wi-Fi credentials to generate QR code for device configuration':
      'Enter Wi-Fi credentials to generate QR code for device configuration',
    'Wi-Fi name': 'Wi-Fi name',
    'Wi-Fi password': 'Wi-Fi password',
    'Enter Wi-Fi network name': 'Enter Wi-Fi network name',
    'Enter Wi-Fi password': 'Enter Wi-Fi password',
    'Generate QR-code': 'Generate QR-code',
    entrance: 'Entrance',
    exit: 'Exit',
  },
  uk: {
    'Scanning Devices': 'Скануючі пристрої',
    'Staff Passes': 'Перепустки персоналу',
    Identifier: 'Ідентифікатор',
    Location: 'Локація',
    'Scanner Type': 'Тип сканера',
    'Create Scanning Device': 'Створити сканер',
    Delete: 'Видалити',
    'Configure scanner': 'Налаштувати сканер',
    'QR-code': 'QR-код',
    'Scan this QR code with your scanning device':
      'Відскануйте цей QR-код вашим скануючим пристроєм',
    'Connect scanning device form': 'Підключення скануючого пристрою',
    'Enter Wi-Fi credentials to generate QR code for device configuration':
      'Введіть дані Wi-Fi для генерації QR-коду налаштування пристрою',
    'Wi-Fi name': 'Назва Wi-Fi',
    'Wi-Fi password': 'Пароль Wi-Fi',
    'Enter Wi-Fi network name': 'Введіть назву Wi-Fi мережі',
    'Enter Wi-Fi password': 'Введіть пароль Wi-Fi',
    'Generate QR-code': 'Згенерувати QR-код',
    entrance: 'Вхід',
    exit: 'Вихід',
  },
};

export const ScanningDeviceForm = {
  en: {
    'Create Scanning Device': 'Create Scanning Device',
    'New Scanning Device': 'New Scanning Device',
    Identifier: 'Identifier',
    Location: 'Location',
    'Scanner Type': 'Scanner Type',
    'Edit Scanning Device': 'Edit Scanning Device',
    'Update Scanning Device': 'Update Scanning Device',
  },
  uk: {
    'Create Scanning Device': 'Створити сканер',
    'New Scanning Device': 'Створення сканера',
    Identifier: 'Ідентифікатор',
    Location: 'Локація',
    'Scanner Type': 'Тип сканера',
    'Edit Scanning Device': 'Оновлення сканера',
    'Update Scanning Device': 'Оновити сканер',
  },
};
